<template>
  <div>
    <div><v-form :name="name" :fields="fields"></v-form></div>

    <VButton
      label="Log In"
      extraClass="auth-submit"
      type=""
      icon="sign-in"
      iconPosition="right"
      :form="name"
      :disabled="!isValid"
      @click="submit"
      submit
    ></VButton>
  </div>
</template>

<script>
import Vue from "vue";
import VButton from "@/components/VButton";
import VForm from "@/components/VForm";
import withNavigate from "@/mixins/withNavigate";
import withToasted from "@/mixins/withToasted";
import withForm from "@/mixins/withForm";
import { required, email } from "@/utils/validations";
import { mapActions } from "vuex";

export default Vue.component("LoginForm", {
  components: {
    VButton,
    VForm
  },

  data() {
    return {
      name: "login",
      fields: [
        {
          name: "email",
          placeholder: "Username",
          extraClass: "auth-input",
          extraClassWrapper: "auth-input-wrapper",
          validate: [required, email]
        },
        {
          name: "password",
          placeholder: "Password",
          type: "password",
          extraClass: "auth-input",
          extraClassWrapper: "auth-input-wrapper",
          validate: [required]
        }
      ]
    };
  },

  mixins: [withNavigate, withToasted, withForm],

  methods: {
    submit() {
      this.validateForm();
      if (this.isValid) {
        this.login({
          data: this.formValues,
          onSuccess: () => {
            this.fetchIdentity({
              onSuccess: identity =>
                this.fetchGravatar({ email: identity[1].email })
            });
            const navigateRoute =
              this.$router.history.current.query &&
              this.$router.history.current.query.redirect
                ? this.$router.history.current.query.redirect
                : "/dashboard";

            this.navigate(navigateRoute);
            this.clearForm();
          },

          onError: () => {
            this.toast(
              "Something went wrong. Check your credentials.",
              "error",
              {
                duration: 3000,
                icon: "close"
              }
            );
          }
        });
      }
    },

    ...mapActions("auth", ["login"]),
    ...mapActions("account", ["fetchIdentity"]),
    ...mapActions("user", ["fetchGravatar"])
  }
});
</script>

<style lang="scss">
.auth-input-wrapper {
  width: 100%;
  margin-top: 15px;
  margin-bottom: 0;

  .auth-input input {
    outline: none;
    background: transparent;
    width: 100%;
    border-radius: 40px;
    padding: 10px 15px;
    font-size: 14px;

    &:hover,
    &:focus {
      border: 1px solid $primary-color;
    }
  }
}

button.auth-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 40px;
  padding: 0 15px;
  font-size: 14px;
  text-align: center;
  background: #4dae51;
  margin-top: 35px;
  color: #fff;
  cursor: pointer;

  &:hover {
    background: #2d9234;
  }

  i {
    font-size: 14px;
    margin-left: 5px;
  }
}
</style>
